/**
 * Templates API - операции с шаблонами email
 */
import apiClient from '../client.js';

/**
 * Получить список всех шаблонов
 * @returns {Promise<Array>} Массив шаблонов
 */
export async function getTemplates() {
  const { data } = await apiClient.get('/outreach/templates');
  return data?.items || [];
}

export async function getMyTemplates() {
  const { data } = await apiClient.get('/outreach/templates', { params: { mine: true } });
  return data?.items || [];
}

/**
 * Получить КОМАНДНЫЕ шаблоны (видимость по роли на бэкенде).
 * @param {{teamId?: string}} [opts] — ADMIN может сузить по команде
 */
export async function getTeamTemplates(opts = {}) {
  const params = opts.teamId ? { teamId: opts.teamId } : {};
  const { data } = await apiClient.get('/outreach/templates', { params });
  return data?.items || [];
}

/**
 * Создать новый шаблон
 * @param {Object} payload - { name, description, channel, subject, body }
 * @returns {Promise<Object>} Созданный шаблон
 */
export async function createTemplate(payload) {
  const { data } = await apiClient.post('/outreach/templates', payload);
  return data?.template;
}

/**
 * Обновить шаблон
 * @param {string} id - ID шаблона
 * @param {Object} payload - { name, description, channel, subject, body }
 * @returns {Promise<Object>} Обновлённый шаблон
 */
export async function updateTemplate(id, payload) {
  const { data } = await apiClient.patch(`/outreach/templates/${id}`, payload);
  return data?.template;
}

/**
 * Удалить шаблон
 * @param {string} id - ID шаблона
 * @returns {Promise<void>}
 */
export async function deleteTemplate(id) {
  await apiClient.delete(`/outreach/templates/${id}`);
}

/**
 * Подтянуть командные шаблоны из Reply.io (ADMIN/TEAM_LEAD).
 * @returns {Promise<{ok, perTeam, totals, note?}>}
 */
export async function importTemplatesFromReply() {
  const { data } = await apiClient.post('/outreach/templates/import-from-reply');
  return data;
}
